/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"

import Navbar from "./navbar"
import Footer from "./footer"
import Gdpr from "./Gdpr/Gdpr"

const Layout = ({ children }) => {
  return (
    <>
      <Navbar />
      <div style={{ paddingTop: "4rem" }}>
        <main style={{ minHeight: "100vh" }}>{children}</main>
      </div>
      <Footer />
      <Gdpr />
    </>
  )
}

export default Layout
